import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M24 4H8V9H24V4Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M20 23H12V24H20V23Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M20 21H12V22H20V21Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M28 14.69C28 13.6477 27.5859 12.6481 26.8489 11.9111C26.1119 11.1741 25.1123 10.76 24.07 10.76H7.93C6.8877 10.76 5.88809 11.1741 5.15107 11.9111C4.41405 12.6481 4 13.6477 4 14.69V23H8V28H24V23H28V14.69ZM22 26H10V19H22V26ZM24.47 15.94C24.1793 15.94 23.8951 15.8538 23.6533 15.6923C23.4116 15.5307 23.2232 15.3012 23.1119 15.0326C23.0006 14.7639 22.9715 14.4684 23.0282 14.1832C23.085 13.8981 23.225 13.6361 23.4306 13.4306C23.6361 13.225 23.8981 13.085 24.1832 13.0283C24.4684 12.9715 24.7639 13.0006 25.0325 13.1119C25.3012 13.2232 25.5307 13.4116 25.6923 13.6533C25.8538 13.8951 25.94 14.1793 25.94 14.47C25.94 14.6631 25.902 14.8542 25.8281 15.0326C25.7542 15.2109 25.6459 15.373 25.5094 15.5095C25.3729 15.646 25.2109 15.7542 25.0325 15.8281C24.8542 15.902 24.663 15.94 24.47 15.94Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
